<script setup>
import {onBeforeMount, ref, reactive, nextTick} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {userInfoStore} from "@/store/store.js";
import {addVoucherUser, listVoucherUserPage} from "@/api/voucher/voucher.js";
import YTVoucherState from "@/components/YTVoucherState/YTVoucherState.vue"
import {memberList} from "@/api/member/member.js"
import {itemList} from "@/api/goods/goods.js";
import {listOperatorAdmin} from "@/api/user/user.js";
import router from "@/router/index.js";

/*初次加载*/
onBeforeMount(async () => {
  await handleGetVoucher('init')
  await handleGetOperator('init')
  await handleSearch()
})
// 处理搜索条件列表：操作人
const handleGetOperator = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationMemberRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationMemberRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationMemberRef.value.getPageSize()
      }
      operatorLoading.value = true
      let res = null
      if (type === 'search') {
        res = await listOperatorAdmin(param, {adminType: 1, nickname: operatorSelectKey.value})
      } else {
        res = await listOperatorAdmin(param, {adminType: 1})
      }
      memberListArr.value = res.list
      memberTotal.value = parseInt(res.total)
      operatorLoading.value = false
    } catch (e) {
      console.log(e)
      operatorLoading.value = false
    }
  })
}
// 操作人选择锚点
const operatorListRef = ref()
// 处理选择器选择操作人
const handleSelectOperator = (e) => {
  const res = memberListArr.value.find(i => i.adminId === e)
  formData.operateUsername = res.username
  console.log("formData", formData)
}
// 电子卡券列表加载状态
const voucherLoading = ref(false)
// 操作人列表加载状态
const operatorLoading = ref(false)
// 处理搜索条件列表：电子卡券
const handleGetVoucher = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationVoucherRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationVoucherRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationVoucherRef.value.getPageSize()
      }
      voucherLoading.value = true
      let res = null
      if (type === 'search') {
        res = await itemList(param, {categoryType: "VOUCHER", keyword: voucherSelectKey.value})
      } else {
        res = await itemList(param, {categoryType: "VOUCHER"})
      }

      voucherListArr.value = res.list
      voucherTotal.value = parseInt(res.total)
      voucherLoading.value = false
    } catch (e) {
      console.log(e)
      voucherLoading.value = false
    }
  })
}
// 用户列表搜索缓存
const cacheUserListKeyword = ref()
// 处理弹窗搜索用户列表
const handleUserListRemoteSearch = (keyword, type = 'init') => {
  cacheUserListKeyword.value = keyword
  handleGetUserList(type)
}
// 处理弹窗获取用户列表
const handleGetUserList = async (type = 'init') => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationDialogMemberRef.value.resetPage()
      }
      let param = {
        page: YTTablePaginationDialogMemberRef.value.getPage(),
        pageSize: YTTablePaginationDialogMemberRef.value.getPageSize()
      }
      dialogLoading.value = true
      let res = null
      if (cacheUserListKeyword.value) {
        res = await memberList(param, {phoneOrNickname: cacheUserListKeyword.value})
      } else {
        res = await memberList(param, {phoneOrNickname: null})
      }
      dialogMemberList.value = res.list
      dialogMemberTotal.value = parseInt(res.total)
      dialogLoading.value = false
    } catch (e) {
      console.log(e)
      dialogLoading.value = false
    }
  })
}
// 电子卡券搜索缓存
const cacheVoucherKeyword = ref()
// 处理弹窗搜索电子卡券
const handleVoucherRemoteSearch = (keyword, type = 'init') => {
  cacheVoucherKeyword.value = keyword
  handleGetVoucherList(type)
}
// 处理弹窗获取电子卡券列表
const handleGetVoucherList = async (type = 'init') => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationDialogVoucherRef.value.resetPage()
      }
      let param = {
        page: YTTablePaginationDialogVoucherRef.value.getPage(),
        pageSize: YTTablePaginationDialogVoucherRef.value.getPageSize()
      }
      dialogLoading.value = true
      let res = null
      if (cacheVoucherKeyword.value) {
        res = await itemList(param, {categoryType:"VOUCHER", keyword: cacheVoucherKeyword.value})
      } else {
        res = await itemList(param, {categoryType:"VOUCHER"})
      }
      dialogVoucherList.value = res.list
      dialogVoucherTotal.value = parseInt(res.total)
      dialogLoading.value = false
    } catch (e) {
      console.log(e)
      dialogLoading.value = false
    }
  })
}
// 用户信息
const userInfo = ref(userInfoStore().info);

// 处理新建卡券记录
const handleAdd = async () => {
  try {
    open.value = true
  } catch (e) {
    console.log(e)
  }
}

/*搜索功能*/
// 表单数据
const formData = reactive({
  phone: null,
  goodsName: null,
  operateUsername: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listVoucherUserPage(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    console.log("tableData.value", tableData.value)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.phone = null
  formData.goodsName = null
  formData.operateUsername = null
  voucherSelectKey.value = null
  operatorSelectKey.value = null
  cacheVoucherKeyword.value = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 表头信息
const headers = ref([
  { title: '用户ID', key: 'userId', nowrap: true },
  { title: '用户昵称', key: 'nickname', nowrap: true },
  { title: '手机号', key: 'phone', nowrap: true },
  { title: '电子卡券', key: 'goodsName', nowrap: true },
  { title: '时间', key: 'crTime', nowrap: true },
  { title: '核销时间', key: 'redeemedTime', nowrap: true },
  { title: '状态', key: 'voucherState', nowrap: true },
  { title: '操作人', key: 'operateUsername', nowrap: true },
  { title: '备注', key: 'note', nowrap: true },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*新建卡券记录*/
// 新建卡券记录弹窗状态
const open = ref(false)
// 对话框表单锚点
const dialogFormRef = ref()
// 对话框表单
const dialogForm = reactive({
  userId: null,
  goodsId: null,
  note: null
})
// 对话框表单校验规则
const dialogRules = reactive({
  userId: [
    {required: true, message: "请选择用户", trigger: 'blur'}
  ],
  goodsId: [
    {required: true, message: "请选择卡券", trigger: 'blur'}
  ],
  note: [
    {required: true, message: "请输入备注", trigger: 'blur'}
  ]
})
// 关闭对话框
const closeDialog = () => {
  open.value = false
  clearDialog()
}
// 确认新建卡券记录
const submitDialog = async () => {
  dialogFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        loading.value = true
        const res = await addVoucherUser(dialogForm)
        console.log(res)
        ElMessage.success("新增成功")
        closeDialog()
        loading.value = false
        await handleSearch()
      } catch (e) {
        console.log(e)
        closeDialog()
        loading.value = false
      }
    } else {
      ElMessage({
        message: "请根据提示修改表单信息",
        type: "error",
        appendTo: "#dialog"
      })
    }
  })
}
// 清除对话框表单校验
const clearDialog = () => {
  dialogForm.userId = null
  dialogForm.goodsId = null
  dialogForm.note = null
  dialogFormRef.value.clearValidate()
}

// 操作人列表
const memberListArr = ref([])
// 电子卡券列表
const voucherListArr = ref([])
// 操作人总数条
const memberTotal = ref(0)
// 电子卡券总条数
const voucherTotal = ref(0)
// 操作人翻页锚点
const YTTablePaginationMemberRef = ref()
// 电子卡券翻页锚点
const YTTablePaginationVoucherRef = ref()
// 处理操作人翻页
const handleChangeMemberPage = () => {
  handleGetOperator()
}
// 处理电子卡券翻页
const handleChangeVoucherPage = () => {
  handleGetVoucher()
}
// 弹窗用户、卡券加载状态
const dialogLoading = ref(false)
// 弹窗用户列表
const dialogMemberList = ref([])
// 弹窗卡券列表
const dialogVoucherList = ref([])
// 弹窗用户列表总条数
const dialogMemberTotal = ref(0)
// 弹窗卡券列表总条数
const dialogVoucherTotal = ref(0)
// 处理弹窗用户列表翻页
const handleChangeDialogMemberPage = () => {
  handleGetUserList()
}
// 处理弹窗卡券列表翻页
const handleChangeDialogVoucherPage = () => {
  handleGetVoucherList()
}
// 弹窗用户翻页锚点
const YTTablePaginationDialogMemberRef = ref()
// 弹窗卡券翻页锚点
const YTTablePaginationDialogVoucherRef = ref()

// 电子卡券下拉搜索值
const voucherSelectKey = ref()
// 操作人下拉搜索值
const operatorSelectKey = ref()

// 跳转到详情
const getDetail = (item) => {
  console.log("item", item)
  router.push({path: "/editEleCardVoucher", query: {voucherUserId: item.voucherUserId}})
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('any', 'voucherUser:add')">新建卡券记录</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.phone"
                        placeholder="请输入手机号"
                        label="手机号"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.goodsName"
                        :items="voucherListArr"
                        item-title="goodsName"
                        item-value="goodsName"
                        label="电子卡券"
                        variant="outlined"
                        :no-data-text="'没有更多数据了~'"
                        :loading="voucherLoading"
                        placeholder="请选择电子卡券"
                    >
                      <template v-slot:prepend-item>
                        <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                          <v-text-field
                              v-model="voucherSelectKey"
                              placeholder="请输入电子卡券名称"
                              label="电子卡券名称"
                              variant="outlined"
                              clearable
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="handleGetVoucher('search')"
                              @keydown.enter="handleGetVoucher('search')"
                              :disabled="voucherLoading"
                          ></v-text-field>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2" v-if="voucherTotal > 0"></v-divider>
                        <YTTablePagination ref="YTTablePaginationVoucherRef" :pageSize="5" :total="voucherTotal" @page-change="handleChangeVoucherPage"></YTTablePagination>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        ref="operatorListRef"
                        v-model="formData.operateUsername"
                        :items="memberListArr"
                        item-title="username"
                        item-value="adminId"
                        label="操作人"
                        variant="outlined"
                        :no-data-text="'没有更多数据了~'"
                        @update:modelValue="handleSelectOperator"
                        :loading="operatorLoading"
                        placeholder="请选择操作人"
                    >
                      <template v-slot:prepend-item>
                        <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                          <v-text-field
                              v-model="operatorSelectKey"
                              placeholder="请输入操作人名称"
                              label="操作人名称"
                              variant="outlined"
                              clearable
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="handleGetOperator('search')"
                              @keydown.enter="handleGetOperator('search')"
                              :disabled="operatorLoading"
                          ></v-text-field>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2" v-if="memberTotal > 0"></v-divider>
                        <YTTablePagination v-if="memberTotal > 0" ref="YTTablePaginationMemberRef" :pageSize="5" :total="memberTotal" @page-change="handleChangeMemberPage"></YTTablePagination>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('any', 'voucherUser:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('any', 'voucherUser:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.nickname=" { item } ">
            {{item.nickname ? item.nickname : "-"}}
          </template>

          <template v-slot:item.goodsName=" { item } ">
            {{item.voucher.goodsName}}
          </template>

          <template v-slot:item.voucherState=" { item } ">
            <YTVoucherState :state="item.voucherState"></YTVoucherState>
          </template>

          <template v-slot:item.note=" { item } ">
            <div :title="item.note">
              {{item.note}}
            </div>
          </template>

          <template v-slot:item.redeemedTime=" { item }">
            <div>{{item.redemptionRecord?.redeemedTime}}</div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="right">
                <v-icon class="" icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)" v-show="$handleHasBtnPermission('any', 'voucherUser:edit')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <el-dialog
      v-model="open"
      title="新建电子卡券"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">新建电子卡券</div>
    </template>
    <el-form
        ref="dialogFormRef"
        style="max-width: 100%"
        :model="dialogForm"
        :rules="dialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="loading"
    >
      <el-form-item label="用  户：" prop="userId">
        <el-select
            v-model="dialogForm.userId"
            filterable
            remote
            reserve-keyword
            placeholder="选择用户"
            remote-show-suffix
            :remote-method="(keyword) => handleUserListRemoteSearch(keyword, 'search')"
            :loading="dialogLoading"
        >
          <el-option
              v-for="item in dialogMemberList"
              :key="item.userId"
              :label="`${item.nickname}(${item.phone})`"
              :value="item.userId"
          />
          <template #footer>
            <YTTablePagination ref="YTTablePaginationDialogMemberRef" :totalVisible="5" :pageSize="5" :total="dialogMemberTotal" @page-change="handleChangeDialogMemberPage"></YTTablePagination>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="卡  券：" prop="goodsId">
        <el-select
            v-model="dialogForm.goodsId"
            filterable
            remote
            reserve-keyword
            placeholder="选择电子卡券商品"
            remote-show-suffix
            :remote-method="(keyword) => handleVoucherRemoteSearch(keyword, 'search')"
            :loading="dialogLoading"
        >
          <el-option
              v-for="item in dialogVoucherList"
              :key="item.goodsId"
              :label="`${item.goodsName}`"
              :value="item.goodsId"
          />
          <template #footer>
            <YTTablePagination ref="YTTablePaginationDialogVoucherRef" :totalVisible="5" :pageSize="5" :total="dialogVoucherTotal" @page-change="handleChangeDialogVoucherPage"></YTTablePagination>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="操作人：" prop="operatorId">
        {{userInfo.username}}
      </el-form-item>
      <el-form-item label="备  注：" prop="note">
        <el-input type="textarea" :rows="5" resize="none" show-word-limit :maxlength="200" placeholder="填写原因。字数小于等于200" v-model="dialogForm.note"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <v-row>
        <v-col cols="5" offset="7">
          <div class="flex_right">
            <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
            <v-btn class="mg_l_1" color="primary" variant="elevated" @click="submitDialog">确定</v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
